import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#528BFF",
      d: "M23.625 1.75c.481 0 .875.394.875.875V5.25h2.625c.481 0 .875.394.875.875a.88.88 0 0 1-.875.875H24.5v2.625a.88.88 0 0 1-.875.875.88.88 0 0 1-.875-.875V7h-2.625a.88.88 0 0 1-.875-.875c0-.481.394-.875.875-.875h2.625V2.625c0-.481.394-.875.875-.875m0 15.75c.481 0 .875.394.875.875V21h2.625c.481 0 .875.394.875.875a.88.88 0 0 1-.875.875H24.5v2.625a.88.88 0 0 1-.875.875.88.88 0 0 1-.875-.875V22.75h-2.625a.88.88 0 0 1-.875-.875c0-.481.394-.875.875-.875h2.625v-2.625c0-.481.394-.875.875-.875M7.481 11.834l-4.517 2.09 4.517 2.083c.378.175.678.476.853.853l2.084 4.517 2.084-4.517c.175-.377.475-.678.853-.853l4.517-2.084-4.517-2.083a1.75 1.75 0 0 1-.853-.853L10.418 6.47l-2.084 4.517a1.75 1.75 0 0 1-.853.853zm-.733 5.764-6.24-2.882a.872.872 0 0 1 0-1.585l6.24-2.883 2.877-6.24a.872.872 0 0 1 1.586 0l2.882 6.24 6.24 2.877a.872.872 0 0 1 0 1.586l-6.235 2.887-2.882 6.235a.872.872 0 0 1-1.586 0z"
    }, null, -1)
  ])))
}
export default { render: render }